import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { value: 10, suffix: "+", label: "Years of experience" },
  { value: 150, suffix: "+", label: "Events & campaigns delivered" },
  { value: 8, suffix: "", label: "Core sectors served" },
  { value: 50, suffix: "+", label: "Institutional partners" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1400;
    const startTime = performance.now();
    const tick = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
};

const Stats = () => {
  return (
    <section data-testid="stats-section" className="py-16 bg-[#0B1B3D]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-center lg:text-left"
          >
            <p className="font-serif-display text-4xl sm:text-5xl font-bold text-white">
              <span className="text-[#D91C29]"><Counter value={s.value} suffix={s.suffix} /></span>
            </p>
            <p className="mt-2 text-sm text-slate-300">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
